import { useEffect, useState, type FormEvent } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { requireSupabase } from '../../lib/supabase';

export function ProfilePage() {
  const { profile, refreshIdentity } = useAuth();
  const [fullName, setFullName] = useState(profile?.full_name || '');
  const [timezone, setTimezone] = useState(profile?.timezone || 'America/Chicago');
  const [format, setFormat] = useState(profile?.format_preference || 'mix');
  const [message, setMessage] = useState('');
  useEffect(() => { setFullName(profile?.full_name || ''); setTimezone(profile?.timezone || 'America/Chicago'); setFormat(profile?.format_preference || 'mix'); }, [profile]);
  const submit = async (event: FormEvent) => {
    event.preventDefault(); if (!profile) return;
    const { error } = await requireSupabase().from('profiles').update({ full_name: fullName, timezone, format_preference: format }).eq('id', profile.id);
    setMessage(error ? error.message : 'Profile updated.');
    if (!error) await refreshIdentity();
  };
  return (
    <div className="hub-page narrow-page"><header className="page-header"><p className="eyebrow">Account</p><h1>Your profile</h1><p>Manage the identity, time zone, and format preferences connected to your hub.</p></header>
      <form className="card settings-form" onSubmit={submit}>
        <label>Full name<input value={fullName} onChange={(e) => setFullName(e.target.value)} /></label>
        <label>Email<input value={profile?.email || ''} disabled /></label>
        <label>Time zone<input value={timezone} onChange={(e) => setTimezone(e.target.value)} /></label>
        <label>Preferred format<select value={format} onChange={(e) => setFormat(e.target.value as typeof format)}><option value="video">Video</option><option value="audio">Audio</option><option value="reading">Reading</option><option value="mix">A mix</option></select></label>
        {message && <div className="form-message success">{message}</div>}
        <button className="button primary">Save profile</button>
      </form>
    </div>
  );
}
